import { useEffect } from 'react';

import { appStore } from "./AppStore";
import { signalRService } from './Services/SignalRService';
import { globalAjaxLoaderStore } from './Stores/GlobalAjaxLoaderStore';
import { AppRouter } from "./AppRouter";
import './App.scss';

export const App = () => {
    let devicePixelRatio: number = 0;
    const resizeHandler = () => {
        if (!devicePixelRatio || devicePixelRatio !== window.devicePixelRatio) {
            devicePixelRatio = window.devicePixelRatio;

            const scrollDiv = document.createElement('div');
            scrollDiv.style.width = '100px';
            scrollDiv.style.height = '100px';
            scrollDiv.style.overflowY = 'scroll';
            scrollDiv.style.visibility = 'hidden';
            document.body.appendChild(scrollDiv);

            const scrollBarWidth = (scrollDiv.offsetWidth - scrollDiv.clientWidth);

            document.body.removeChild(scrollDiv);
            document.body.style.setProperty('--scrollbar-width', scrollBarWidth + 'px');
        }
    };

    const hideAppLoader = () => {
        const loader = document.getElementById('react-app-loader');
        const message = document.getElementById('react-app-loader-message');
        if (loader && message) {
            globalAjaxLoaderStore.appLoaderElement = loader;
            globalAjaxLoaderStore.appLoaderMessageElement = message;
            loader.addEventListener(
                'transitionend',
                () => {
                    if (loader.classList.contains('hide')) {
                        loader.classList.add('invisible');
                    }
                },
                true
            );
        }
        resizeHandler();
    };

    const keydownHandler = (event: KeyboardEvent) => {
        // event.metaKey - On Macintosh keyboards, this is the ⌘ Command key
        appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey);
        appStore.isShiftKey = event.shiftKey;
    };

    const keyupHandler = (event: KeyboardEvent) => {
        appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey);
        appStore.isShiftKey = event.shiftKey;
    };

    useEffect(() => {
        signalRService.ref();
        hideAppLoader();
        document.addEventListener('keydown', keydownHandler, true);
        document.addEventListener('keyup', keyupHandler, true);
        window.addEventListener('resize', resizeHandler);
        resizeHandler();
    }, []);

    return (
        <div className="App">
            <AppRouter />
        </div>
    );
};